const cpnEnLang = {
  exportComponent_exportPdf: 'Export pdf',
  exportComponent_exportExcel: 'Export excel',
  exportComponent_checkAll: 'Check all',
  // single Upload
  singleUpload_Upload: 'Upload image',
  singleUpload_Error: 'Upload error',
  singleUpload_ErrorMaxFileSize: 'Image must smaller than {{maxFileSize}}MB!',
  // import
  importModal_ClickOrDrag2Upload: 'Click or drag file to this area to upload',
  importModal_HintText: `<b>1</b>. Please enter the appropriate data in each cell for the columns listed below<br/>
                         <b>2</b>. If the data is incorrect, the system will not process this record.<br/>
                         <b>3</b>. Only records for which each cell value already exists in the system will be processed.<br/>
                         `,
  importModal_ColumnsHintText: 'Import work for excel files with required columns',
  importModal_ImportResponse: 'Import response',
  importModal_InsertedRecords: 'Inserted records',
  importModal_InvalidRecords: 'Invalid records',
  importModal_LogUrl: 'Log Url',
  importModal_totalRecords: 'Total Record',
  importModal_DownloadSampleFle: 'Download sample file to import',

  //Global Tariff Parameters
  goSettingsPage_Title: 'Settings',
  goSettingsPage_BaseTariff: 'Base tariff',
  goSettingsPage_BaseTicketClass: 'Base ticket class',
  goSettingsPage_TariffParamsSearchText: 'Tariff name, code...',
  goSettingsPage_TariffCategory: 'Tariff category',
  goSettingsPage_TariffParams_Name: 'Tariff name',
  goSettingsPage_CreateTariffParams: 'Create base tariff parameters',
  goSettingsPage_UpdateTariffParams: 'Update base tariff parameters',
  goSettingsPage_TariffParameters: 'Base Tariff Parameters',
};
export default cpnEnLang;
